module.exports = __webpack_public_path__ + "img/dashboard.7d0f46f8.svg";